import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStatus } from './useAuthStatus'
import store from '../store'
import { clearSession } from '../session/actions'

export const RedirectIfAuthenticated: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const { admin, authenticated, invalidSession } = useAuthStatus()
  const location = useLocation()

  // If we're on a public route (like signup or root) and have an invalid session,
  // clear the invalidSession flag since it's likely a false positive from token validation
  // attempts on first visit when there are no tokens yet
  if (invalidSession && !authenticated) {
    // Dispatch action to clear the invalid session flag but keep other state the same
    store.dispatch(clearSession({ invalidSession: false }))

    // Return children directly since we're on a public route - no need to redirect
    return children
  }

  if (authenticated) {
    return (
      <Navigate
        to={admin ? '/admin' : '/app'}
        state={{ from: location }}
        replace
      />
    )
  }

  return children
}
